import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		userInfo: null, //用户的信息集合
		addRoutes: null,
		memberId: 1
	},
	mutations: {
		// 对用户的信息进行修改，重新赋值
		editUserInfo(state, userInfo) {
			state.userInfo = userInfo;
		},
		addRoutes(state, addRoutes) {
			state.addRoutes = addRoutes;
		},
		memberId(state, memberId) {
			state.memberId = memberId;
		},
	},
	actions: {}
});
export default store;
